package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/bluey". Pulls the REAL cached analysis from PROD. */
@Page("/isitsafe/bluey")
@Composable
fun BlueyReviewPage() {
    PublicReviewPage(
        slug = "bluey",
        blurb = "Is Bluey a good choice for a Muslim family? Fitrah Filter checks movies, shows, and games against Islamic values. Here's our breakdown of what's great, what to be aware of, and why.",
    )
}
